module.exports = __webpack_public_path__ + "img/transparent-nav-right-kia.285ee25d.png";